// The practice tutorial is remembered per viewer in localStorage (like the look); the server also keeps it per player.
export const TUTORIAL_KEY = 'door.tutorial';

export function tutorialDone(storage = globalThis.localStorage) {
  try { return storage.getItem(TUTORIAL_KEY) === 'done'; } catch { return false; /* private mode */ }
}
// The inspector brief (game/tutorial.js INSPECTOR_BRIEF) is shown once per viewer, before the first knock.
export const BRIEF_KEY = 'door.brief';
export function briefSeen(storage = globalThis.localStorage) {
  try { return storage.getItem(BRIEF_KEY) === 'seen'; } catch { return false; /* private mode: shown each visit */ }
}
export function rememberBrief(storage = globalThis.localStorage) {
  try { storage.setItem(BRIEF_KEY, 'seen'); } catch { /* private mode: lasts only this page */ }
}
export function rememberTutorial(storage = globalThis.localStorage) {
  try { storage.setItem(TUTORIAL_KEY, 'done'); } catch { /* private mode: lasts only this page */ }
}
